/**
 * Return true if value is not undefined and not null
 * @param value 
 */
export function isPresent(value: any): boolean {
    return value !== undefined && value !== null;
}

/**
 * Returns true if value is null or empty string
 * @param value 
 */
export function stringIsNullOrEmpty(value: string): boolean {
    return value === undefined || value === null || value === '';
}

/**
 * Returns true if value is null, undefined or empty
 * @param value 
 */
export function valueIsNullOrEmpty(value: any): boolean {
    if (isPresent(value)) {
        if (typeof value === 'string') {
            return value === '';
        }
        return false;
    }
    return true;
}

/**
 * Returns true if value is an object
 * @param item 
 */
export function isObject(item: any): boolean {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * mergeDeep will merge object graph
 * @param target 
 * @param source 
 */
export function mergeDeep(target: any, source: any): any {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                } else {
                    output[key] = mergeDeep(target[key], source[key]);
                }
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        }); 
    }
    return output;
}  

/**
 * Returns true if IE10
 */
export function isIE10() {
    return navigator.appVersion.indexOf("MSIE 10") !== -1;
}

/**
 * Returns the host including port from a given url (must start with http which is the case for onePay hosted field)
 *   example: given url      https://payment-page.pp.au.emagin.world/index.html?sessionId=PQIOA5Q2JBAZJF5NBSYMFWNL2I 
 *            will return    https://payment-page.pp.au.emagin.world
 * @param value url to extract host
 */
export function getHostUrl(value: string): string {
    if (stringIsNullOrEmpty(value)) return value;

    const regEx = new RegExp(/(.+?\:\/\/.+?)(\/.+?)(?:#|\?|$)/);
    const matches = regEx.exec(value);
    if (isPresent(matches) && matches.length >= 2) {
        return matches[1];
    }
    return value;
}


// WEBPACK FOOTER //
// ./src/helpers.ts